import { apiClient } from '~/services/api-service';
import { Id } from '~/types/common';

export const websiteAPIService = {
  createWebsiteSite: (body) => {
    return apiClient.post(`/microsite/website/`, body);
  },
  updateWebsiteSite: ({ id, body }: { id: Id; body: any }) => {
    return apiClient.patch(`/microsite/website/${id}/`, body);
  },
  getWebsiteSite: ({ id }: { id: Id }) => {
    return apiClient.get(`/microsite/website/${id}/`);
  },
};
